/**
 * @generated SignedSource<<949d97252c602ea490edd871faa19f74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ClientEngagementPageQuery$variables = {
  id: string;
};
export type ClientEngagementPageQuery$data = {
  readonly myEngagement: {
    readonly assets: ReadonlyArray<{
      readonly assetTag: any;
      readonly id: string;
      readonly name: string;
    }>;
    readonly budget: string | null | undefined;
    readonly createdAt: any;
    readonly details: string;
    readonly id: string;
    readonly interests: ReadonlyArray<string>;
    readonly modelFiles: ReadonlyArray<{
      readonly byteSize: number;
      readonly filename: string;
      readonly id: string;
    }>;
    readonly projectName: string | null | undefined;
    readonly scanDetails: any;
    readonly startsOn: any | null | undefined;
    readonly status: string;
    readonly talent: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly wantsConsultation: boolean;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
};
export type ClientEngagementPageQuery = {
  response: ClientEngagementPageQuery$data;
  variables: ClientEngagementPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Engagement",
    "kind": "LinkedField",
    "name": "myEngagement",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "interests",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "details",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startsOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "budget",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "wantsConsultation",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scanDetails",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "assets",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetTag",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TalentProfile",
        "kind": "LinkedField",
        "name": "talent",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "modelFiles",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "byteSize",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientEngagementPageQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientEngagementPageQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "04684cb6a7e9d44249082e2fa4fcc348",
    "id": null,
    "metadata": {},
    "name": "ClientEngagementPageQuery",
    "operationKind": "query",
    "text": "query ClientEngagementPageQuery(\n  $id: ID!\n) {\n  viewer {\n    id\n  }\n  myEngagement(id: $id) {\n    id\n    interests\n    projectName\n    details\n    startsOn\n    budget\n    status\n    createdAt\n    wantsConsultation\n    scanDetails\n    assets {\n      id\n      assetTag\n      name\n    }\n    talent {\n      id\n      name\n    }\n    modelFiles {\n      id\n      filename\n      byteSize\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4c3a4d59fa6fe819c082625f676f637";

export default node;
